import styled, { css } from 'styled-components';

import { inlineMediaQueryMixin, Table, token } from '@zillow/constellation';

const widthCSS = (mediaProps: { width: string | number }) => css`
  width: ${mediaProps.width};
`;

export const StyledProductOptionContentContainer = styled.div`
  position: relative;
  /* value must be height of StyledBottomButton */
  padding-bottom: 44px;
  text-align: left;
  height: 100%;
`;

export const StyledTableHeaderCell = styled(Table.HeaderCell)`
  && {
    background-color: ${(props) => token(`colors.${props.backgroundColor}`)};
    ${inlineMediaQueryMixin('width', widthCSS)}
  }
`;

export const StyledTableCell = styled(Table.Cell)`
  &&& {
    background-color: ${(props) => token(`colors.${props.backgroundColor}`)};
    padding-left: ${({ removeLeftPadding }) => (removeLeftPadding ? '0' : '16px')};
    border-bottom: ${({ removeBorderBottom }) => removeBorderBottom && '0'};
  }
`;
